import { Components } from '@mui/material';

export default {
  styleOverrides: { root: { '&.MuiSelect-icon': { color: '#52555A' } } },
} as Components;
